module.exports = __webpack_public_path__ + "img/20191204172121631.5b85cdd9.jpg";